"use client"

import type { TrackEventProperties } from "@/modules/tracking/types"
import type { FunctionComponent } from "react"

import { useEffect } from "react"

import { useTracking } from "@/modules/tracking/useTracking"

type TrackRenderProps = {
  delay?: number
  trackingProps: TrackEventProperties
}

export const TrackRender: FunctionComponent<TrackRenderProps> = ({
  delay = 0,
  trackingProps: { eventName, eventProperties },
}) => {
  const tracking = useTracking()

  useEffect(() => {
    setTimeout(() => {
      tracking?.track(eventName, eventProperties)
    }, delay)
  }, [delay, tracking, eventName, eventProperties])

  return null
}
